export default "__VITE_ASSET__P0xiEn4a__"